/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.09.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import L from 'external/leaflet';
import React from 'external/react';
import PropTypes from 'external/prop-types';
import ReactDOM from 'external/react-dom';
import LayerInfoSidebar from '../components/LayerInfoSidebar';

//https://stackoverflow.com/questions/30703212/how-to-convert-radius-in-metres-to-pixels-in-mapbox-leaflet
// used to define a buffer around the clicked point
const getMetresPerPixel = (map) => 40075016.686 * Math.abs(Math.cos(map.getCenter().lat * Math.PI / 180)) / Math.pow(2, map.getZoom() + 8);

export default class LayerInfoPlugin {

    constructor(props, config) {
        this.config = config;
        this.props = props;

        this._marker = L.marker([ 0, 0 ], {
            icon: L.icon({
                iconUrl: '/o/de.xdot.liferay.map.web/icons/pin.png',
                popupAnchor: [ 0, -64 ],
                iconSize: [ 28, 56 ],
                iconAnchor: [ 14, 56 ]
            })
        });

        this.onMapClick = this.onMapClick.bind(this);
        this.updateTitle = this.updateTitle.bind(this);
        this.onHide = this.onHide.bind(this);
    }

    withCtx(s) {
        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
    }

    initOptions(o) {
        this.o = o;
        return this.options(o);
    }

    options(o) {
        return o;
    }

    init(map, o, reEvaluate) {
        this.reEvaluate = reEvaluate;
        this._map = map;
        const sidebarContent = L.DomUtil.create('div', '', map.getContainer());
        const btn = L.DomUtil.create('div', 'sidebar-btn right');
        btn.setAttribute('role', 'button');
        btn.setAttribute('title', 'Themen & Lagekarten');
        this.btnContent = L.DomUtil.create('div', 'sidebar-btn__content', btn);
        this.sidebar = L.control.sidebar(sidebarContent, { position: 'right', closeButton: false });

        this.sidebar.on('show', this.updateTitle);
        this.sidebar.on('hide', this.onHide);
        this.updateTitle();

        map.addControl(this.sidebar);
        const content = this.sidebar.getContainer();
        btn.onclick = (e) => {
            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            this.sidebar.toggle();
        };
        content.parentNode.insertBefore(btn, content);

        this._map.on('click', this.onMapClick);
    }

    updateTitle() {
        const icon = this.sidebar.isVisible() ? 'left' : 'right';
        this.btnContent.innerHTML = '<span class="sidebar-situationmap-name">' + 'Objektinfo & Legende' + '</span>' + '<span class="icon icon-fliwas-arrow-' + icon + ' left" title=""></span>';
    }

    onHide() {
        this.updateTitle();
        this._marker.remove();
    }

    update(map, o) {
        this.o = o;
        ReactDOM.render(
            <LayerInfoSidebar
                layerDescriptions={ o.layerDescriptions }
                onClose={ () => this.sidebar.hide() }
                activeLayerUuids={ this.o.activeUuids }
                layers={ this._map._layers }
                latlng={ this.latlng }
                metresPerPixel={ this.metresPerPixel }
            />,
            this.sidebar.getContainer()
        );
    }

    remove() {
        this._map = null;
    }

    onMapClick(e) {
        if (!this._map.blockingControlActive) {
            const { latlng } = e;
            this.latlng = latlng;
            this.metresPerPixel = getMetresPerPixel(this._map);
            this._marker.setLatLng(latlng);
            this._marker.addTo(this._map);
            this.sidebar.show();
            this.reEvaluate({ latlng, metresPerPixel: this.metresPerPixel });
        }
    }
}

LayerInfoPlugin.contextTypes = {
    contextId: PropTypes.string
};



// WEBPACK FOOTER //
// ./js/plugins/LayerInfoPlugin.js